import React from 'react'; 

const Header = () => {
  return <header id="header" className="ph-header-main"></header>;
};
export default Header;
